import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';

export const GETRegistroDocumentDownloadLink = async (
  dispatch: Dispatch,
  documentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    async () =>
      await axiosInstance.get<string>(
        `${requestConfig.api}api/v1/registros/historicos/documents/${documentId}/download`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
